import React from "react";
import globalStyles from '../../Styles/Style.module.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBoxOpen, faLightbulb} from "@fortawesome/free-solid-svg-icons";
import {encode} from "../../Services/ObfuscatorService"
import moment from "moment";
import ThemeBadge from "../Utils/ThemeBadge";
import Cookies from 'universal-cookie';

const cookieOptions = { maxAge: `${process.env.REACT_APP_COOKIE_BASKET_MAX_AGE}`, path: '/', domain: `${process.env.REACT_APP_COOKIE_DOMAIN}` }
const cookies = new Cookies(null, cookieOptions);

function CardSuggestNextBox(props) {

    function updateCookie(reference) {
        // Récupérer le cookie 'basketQuantity'
        let pastRef = cookies.get('basketQuantity');

        // Vérifier si la référence existe déjà dans l'objet
        if (pastRef[reference]) {
            // Si oui, augmenter la quantité de 1
            pastRef[reference] += 1;
        } else {
            // Si non, ajouter la référence avec quantité 1
            pastRef[reference] = 1;
        }

        // Mettre à jour le cookie avec le nouvel objet JSON
        cookies.set('basketQuantity', JSON.stringify(pastRef), cookieOptions);
        cookies.set('lastchanger', "client", cookieOptions);
        

        let jsonProduct = new FormData()
        jsonProduct.append("json", JSON.stringify([reference]))
        let requestAdd = new Request(process.env.REACT_APP_API_URL + '/client/basket/add', { method: 'POST', credentials: 'include', body: jsonProduct })
        fetch(requestAdd).then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            else
            {
                window.location.href = '/basket';
            }
        })
        
    }

    

    return (
        <div
            className={`${globalStyles.card} ${globalStyles.cardMore}`}
            style={{padding: "20px",}}
        >

            <h3 style={{margin: "10px 0"}}>
                <FontAwesomeIcon icon={props.commitment ? faBoxOpen : faLightbulb} style={{marginRight: "10px"}}/>
                {
                    props.commitment ?
                        "Prochaine box pour " + props.name
                        :
                        "Notre suggestion pour " + props.name
                }
            </h3>

            <div style={{display: "flex", flexDirection: window.innerWidth > 1020 ? "row" : "column"}}>

                <div style={{flexDirection: "column", marginTop: "26px", display: "flex", flex: 1}}>
                    <div style={{textAlign: "center", fontSize: "1,3em", display: "flex", alignItems: "center", justifyContent:"center"}}>
                        <div style={{width: "150px"}}>
                            <img
                                alt=""
                                src={process.env.REACT_APP_CDN_URL + '/uploads/article/' + props.media}
                                style={{maxWidth: "100%", maxHeight: "100%", borderRadius: "8px", marginBottom: "5px"}}
                            />
                        </div>
                    </div>
                    <div style={{marginLeft: "10px", marginTop: "5px", textAlign: "center"}}>
                        <div style={{textAlign: "center", fontWeight: 500}}>
                            {props.boxName}
                        </div>
                        <div style={{fontSize: "14px", marginTop: "15px"}}>
                            <ThemeBadge
                                theme={props.theme}
                                bgColor={props.themeColor}
                                baseColor={props.themeBaseColor}
                            />

                            {props.secondaryTheme &&
                                <ThemeBadge
                                    theme={props.secondaryTheme}
                                    bgColor={props.secondaryThemeColor}
                                    baseColor={props.secondaryThemeBaseColor}
                                    style={{marginLeft: "5px"}}
                                />
                            }
                        </div>
                    </div>
                </div>

                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flex: 2,
                        flexDirection: "column",
                        marginTop: window.innerWidth < 1020 ? "10px" : undefined
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center"
                        }}
                    >
                        <div
                            style={{
                                textAlign: "center",
                                color: "black",
                                marginBottom: props.last ? "15px" : "32px",
                            }}
                        >
                            {
                                props.commitment ?
                                    <span>Voilà la box que nous préparons pour toi. <br/>
                                        {props.choose ?
                                            <span>Tu as jusqu'au <b>{moment(props.date).format("DD/MM/YYYY")}</b> pour changer.</span>
                                            :
                                            <span>Tu la recevras d'ici le <b>{moment(props.date).format("DD/MM/YYYY")}</b>.</span>}
                                </span>
                                    :
                                    props.description
                            }
                        </div>


                        {
                            props.commitment ?
                                (props.choose ?
                                        <a
                                            className={globalStyles.defaultBtn}
                                            href={"/commitment/choose/" + encode(props.chooseId)}
                                            style={{fontSize: "1rem"}}
                                        >
                                            Changer
                                        </a>
                                        :
                                        ""
                                )
                                :
                                <button
                                    className={globalStyles.defaultBtn}
                                    style={{fontSize: "1rem"}}
                                    onClick={() => updateCookie(props.reference)}
                                >
                                    Ajouter au panier
                                </button>
                        }
                    </div>

                    {props.last &&
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                flex: 2,
                                flexDirection: "column",
                                marginTop: window.innerWidth < 1020 ? "10px" : undefined
                            }}
                        >
                            <div
                                style={{
                                    textAlign: "center",
                                    color: "black",
                                    marginTop: "32px",
                                    marginBottom: "15px"
                                }}
                            >
                                C'est la dernière box de ton abonnement, <br/> pense à le renouveler !
                            </div>

                            <a
                                className={globalStyles.defaultBtn}
                                style={{fontSize: "1rem"}}
                                onClick={() => updateCookie(props.commitmentRef)}
                            >
                                Renouveler
                            </a>
                        </div>
                    }

                </div>



            </div>

        </div>
    );
}

export default CardSuggestNextBox;
